import React, { PropsWithChildren } from 'react';
import { Col, Row } from 'react-bootstrap';

export type SummaryBlockProps = {
    display: boolean,
    className?: string
}

export const SummaryBlock = (props: PropsWithChildren<SummaryBlockProps>) => {

    return props.display ? (
        <Row className={props.className}>
            <Col>
                {props.children}
            </Col>
        </Row>
    ) : null;
}
